import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';
import { Alerts } from '../components/Alerts';
import Home from '../sections/Home';
import NotFound from '../sections/NotFound';
import { routes } from '../routes';
import { TfsRoute } from '../routes/Route';
import Header from '../components/Header/Header';
import { EnvironmentIdentifier } from '../components/EnvironmentIdentifier';
import { VersionChecker } from '../components/VersionChecker';
import { Provider as AdminProvider } from '../sections/admin/context';
import FieldBoundaryManagement from '../sections/field-boundary-management/FieldBoundaryManagement';
import GrowerManagement from '../sections/grower-management/GrowerManagement';
import OperationManagement from '../sections/grower-management/OperationManagement';
import OrganizationManagement from '../sections/organization-management/OrganizationManagement';
import UserManagement from '../sections/user-management/UserManagement';
import PotentialProductivity from '../sections/potential-productivity/PotentialProductivity';
import Nrx from '../sections/nrx/Nrx';
import SoyRXPage from '../sections/soyrx/SoyRXPage';
import Lpk from '../sections/lpk/Lpk';
import NProtectant from '../sections/n-protectant/NProtectant';
import EarlySeasonFungicide from '../sections/early-season-fungicide/EarlySeasonFungicide';
import GrowerYield from '../sections/yield-display/GrowerYield';
import CornRXPage from '../sections/cornrx/CornRXPage';
import FieldBoundaryUpload from '../sections/field-boundary-upload/FieldBoundaryUpload';
import PlantingUpload from '../sections/planting-upload/PlantingUpload';
import YieldUpload from '../sections/yield-upload/YieldUpload';
import SoilCsvUpload from '../sections/soil-pending-fields/SoilCsvUpload';
import PendingFields from '../sections/soil-pending-fields/PendingFields';
import EoyReport from '../sections/eoy/EoyReport';
import SoilReport from '../sections/soil/SoilReport';
import FieldAgrilytics from '../sections/field-agrilytics/FieldAgrilytics';
import AdminDashboard from '../sections/admin/AdminDashboard';

const SoilSamplingInternalDashboard = lazy(
  () => import('../sections/soil-sampling/internal/FieldSpecialistDashboard'),
);

const SoilSampleOrderPage = lazy(
  () => import('../sections/soil-sampling/orders/OrderPage'),
);

const SoilSampleOrderAdminPage = lazy(
  () => import('../sections/soil-sampling/admin/AdminPage'),
);

const SoilSampleOrderDashboardPage = lazy(
  () => import('../sections/soil-sampling/orders/Dashboard'),
);

const StarterFertilizerPage = lazy(
  () => import('../sections/starter-fertilizer/StarterFertilizerPage'),
);

const Planting = lazy(() => import('../sections/planting/PlantingPage'));
const Deere = lazy(() => import('../sections/deere/Deere'));
const Signal = lazy(() => import('../sections/signal/Signal'));

const componentRegistry = {
  CornRXPage,
  Deere,
  EarlySeasonFungicide,
  EoyReport,
  FieldBoundaryManagement,
  FieldBoundaryUpload,
  GrowerManagement,
  GrowerYield,
  SoilSamplingInternalDashboard,
  Lpk,
  NProtectant,
  Nrx,
  OperationManagement,
  OrganizationManagement,
  PendingFields,
  Planting,
  PlantingUpload,
  PotentialProductivity,
  SoilCsvUpload,
  SoilReport,
  SoilSampleOrderAdminPage,
  SoilSampleOrderDashboardPage,
  SoilSampleOrderPage,
  SoyRXPage,
  StarterFertilizerPage,
  Signal,
  UserManagement,
  YieldUpload,
  AdminDashboard,
  FieldAgrilytics,
};

export function Desktop() {
  return (
    <AdminProvider>
      <EnvironmentIdentifier
        className="app"
        sx={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <VersionChecker>
          <Header />
          <Box sx={{ flex: 1, overflow: 'hidden' }}>
            <Alerts />
            <Routes>
              <Route exact path="/" element={<Home />} />
              {routes.map(renderRoute)}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
        </VersionChecker>
      </EnvironmentIdentifier>
    </AdminProvider>
  );
}

function renderRoute(routeConfig, key) {
  const { component, ...passThrough } = routeConfig;
  const Child = componentRegistry[component];

  return (
    <Route
      key={key}
      {...passThrough}
      element={
        <TfsRoute {...passThrough}>
          <Child />
        </TfsRoute>
      }
    />
  );
}
